import type { Span } from "types/spans.types"

import useConductor from "helpers/hooks/conductors/useConductor"
import CardWithTitle from "widgets/common/CardWithTitle"
import ConductorSpec from "widgets/conductors/ConductorSpec"
import Message from "widgets/common/Message"
import Spinner from "widgets/common/Spinner"

interface SpanConductorProps {
  span: Span
}

/**
 * The conductor this span is strung with, read as its datasheet. The power line
 * opens the same spec in a dialog, one conductor among several; here there is
 * only ever this one, so it lays out in the section.
 */
const SpanConductor = ({ span }: SpanConductorProps) => {
  const { conductor, isFetching } = useConductor({ id: span.conductor_id })

  return (
    <CardWithTitle titleKey="conductors.CONDUCTOR">
      {isFetching ? (
        <Spinner styles={{ my: 2 }} />
      ) : conductor ? (
        <ConductorSpec conductor={conductor} />
      ) : (
        <Message
          messageKey="conductors.CONDUCTOR_UNAVAILABLE"
          containerStyles={{ height: "100%", minHeight: "120px" }}
        />
      )}
    </CardWithTitle>
  )
}

export default SpanConductor
